
import LolePicture from '~/components/picture/lole-picture'
import LoleVideoPicture from '~/components/picture/lole-video-picture'
export default {
  components: { LolePicture, LoleVideoPicture },
  props: {
    medias: {
      type: Array,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    galleryLayoutClass() {
      return this.medias.length < 5 || this.medias.length > 10
        ? 'gallery-default'
        : `gallery-${this.medias.length}`
    },
  },
}
